export const featuresVashaAcademy = [
  {
    id: 'live-class',
    icon: '/Images/vasha-academy/features/feature-1.png',
    titleKey:
      'vasha-academy-home-page.feature-section.features.live-class.title',
    descriptionKey:
      'vasha-academy-home-page.feature-section.features.live-class.description',
  },
  {
    id: 'video-class',
    icon: '/Images/vasha-academy/features/feature-2.png',
    titleKey:
      'vasha-academy-home-page.feature-section.features.video-class.title',
    descriptionKey:
      'vasha-academy-home-page.feature-section.features.video-class.description',
  },
  {
    id: 'quiz',
    icon: '/Images/vasha-academy/features/feature-3.png',
    titleKey: 'vasha-academy-home-page.feature-section.features.quiz.title',
    descriptionKey:
      'vasha-academy-home-page.feature-section.features.quiz.description',
  },
  {
    id: 'voice-quiz',
    icon: '/Images/vasha-academy/features/feature-4.png',
    titleKey:
      'vasha-academy-home-page.feature-section.features.voice-quiz.title',
    descriptionKey:
      'vasha-academy-home-page.feature-section.features.voice-quiz.description',
  },
  {
    id: 'assignment-upload',
    icon: '/Images/vasha-academy/features/feature-5.png',
    titleKey:
      'vasha-academy-home-page.feature-section.features.assignment-upload.title',
    descriptionKey:
      'vasha-academy-home-page.feature-section.features.assignment-upload.description',
  },
  {
    id: 'user-dashboard',
    icon: '/Images/vasha-academy/features/feature-6.png',
    titleKey:
      'vasha-academy-home-page.feature-section.features.user-dashboard.title',
    descriptionKey:
      'vasha-academy-home-page.feature-section.features.user-dashboard.description',
  },
];
